import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import { makeStyles } from '@mui/styles';
import { useState } from '@hookstate/core';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import TextField from '@mui/material/TextField';

const useStyles = makeStyles({
    boxContent: {
        display: 'flex',
        justifyContent: 'center',
    },
});

const AdminNote = (props) => {
    const classes = useStyles();
    const userNote = useState('');
    const loading = useState(false);
    useEffect(() => {
        if (props.data) {
            userNote.set('');
        }
    }, [])
    const renderDialogContent = () => {
        return (
            <Box className={classes.boxContent}>
                <TextField
                    fullWidth
                    id="outlined-multiline"
                    label="Notes"
                    multiline
                    rows={4}
                    value={userNote.get()}
                    onChange={(event) => userNote.set(event.target.value)}
                    inputProps={{ maxLength: 1000 }}
                />
            </Box>
        );
    };

    const handleClick = () => {
        loading.set(true);
        props.updateNote(userNote.value);
    };

    const renderDialogActions = () => (
        <ButtonContainer
            showLoading={true}
            loading={loading.get()}
            handleClick={handleClick}
            handleCancel={props.handleClose}
            buttonText={'Submit'}
        />
    );

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default AdminNote;
